/**
 * Hover details card for review workflow stages (reviewerData payload).
 */
import React, { useState } from 'react';
import { User } from 'lucide-react';

const getInitials = (name) => {
  if (!name || name === 'Pending Assignment') return null;
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return null;
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const WorkflowReviewerCard = ({ reviewerData }) => {
  const [imgFailed, setImgFailed] = useState(false);

  if (!reviewerData) return null;

  const isActive = reviewerData.status_state === 'active';
  const isPending = reviewerData.name === 'Pending Assignment';
  // A finished step with no recorded person shows its date alone
  const hasPerson = Boolean(reviewerData.name);
  const initials = getInitials(reviewerData.name);
  const showAvatarImg = Boolean(reviewerData.avatar_url) && !imgFailed && !isPending;

  return (
    <div
      className={`garage-workflow-reviewer-card ${
        isActive ? 'is-active' : 'is-completed'
      }`}
      role="tooltip"
    >
      {reviewerData.team && (
        <div className="garage-workflow-reviewer-team">
          Team: {reviewerData.team}
        </div>
      )}

      {hasPerson && (
        <div className="garage-workflow-reviewer-person">
          {!isPending && (
            <div className="garage-workflow-reviewer-avatar" aria-hidden="true">
              {showAvatarImg ? (
                <img
                  src={reviewerData.avatar_url}
                  alt=""
                  onError={() => setImgFailed(true)}
                />
              ) : initials ? (
                <span className="garage-workflow-reviewer-initials">{initials}</span>
              ) : (
                <User size={14} />
              )}
            </div>
          )}
          <span className="garage-workflow-reviewer-name">{reviewerData.name}</span>
        </div>
      )}

      <div
        className={`garage-workflow-reviewer-status ${
          isActive ? 'status-active' : 'status-completed'
        }`}
      >
        {reviewerData.status_text}
      </div>
    </div>
  );
};

export default WorkflowReviewerCard;
